import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators, FormControl, FormArray } from "@angular/forms";
import * as CONSTANT from "../../../services/constants";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../../services/admin.service";
import { apiUrl } from "../../../global/global";
import { HttpParams, HttpClient } from "@angular/common/http";
import { ToastrService } from "ngx-toastr";
import { UsernameValidator } from "../../../services/NoWhiteSpace.validator";

@Component({
  selector: "app-add-edit-user",
  templateUrl: "./add-edit-user.component.html",
  styleUrls: ["./add-edit-user.component.css"]
})
export class AddEditUserComponent implements OnInit {
  usersForm: FormGroup;
  userID:any;
  showError = false;
  titles = "Add";
  dropdownSettings:any;
  dropdownList:any = []
  allGroup:any = [];
  usersData:any=[];
  selectedGroup:any = [];
  accessList = [
		{
			name: "Jobs",
			placeholder : [
				{title: "Create Job", key: "createJob", permission:0},
				{title: "View Team Member’s jobs", key: "viewTeamMemberJob", permission:0},
				{title: "Edit Team Member’s Jobs", key: "editTeamMemberJob", permission:0},
			]
		},
    {
			name: "Team",
			placeholder : [
				{title: "Add Team Member", key: "addTeamMember", permission:0},
				{title: "Edit Team Member", key: "editTeamMember", permission:0},
				{title: "Delete Team Member", key: "deleteTeamMember", permission:0},
			]
		},
    {
			name: "Licensing",
			placeholder : [
				{title: "View Active Plan and Inventory", key: "viewActivePlans", permission:0},
				{title: "View Invoice and Purchase History", key: "viewInvoice", permission:0},
				// {title: "Buy Inventory", key: "buyInventory", permission:0},
        // {title: "Cancel Subscriptions", key: "cancelSubscription", permission:0},
			]
		},
    {
			name: "Other Permissions",
			placeholder : [
				{title: "Dashboard", key: "dashboard", permission:0},
				{title: "Search", key: "search", permission:0},
				{title: "Messages", key: "messages", permission:0},
        // {title: "Reports", key: "reports", permission:0},
        {title: "My Candidate", key: "myCandidate", permission:0},
			]
		},
  ]  
  constructor(private formBuilder: FormBuilder,public route: ActivatedRoute, private router: Router,private api: AdminService,private toastrService: ToastrService) {
    this.usersForm = this.formBuilder.group({
      id:[""],
      fullName: ["", Validators.compose([Validators.required,Validators.minLength(3),Validators.maxLength(50),Validators.pattern("[a-zA-Z][a-zA-Z ]+"),UsernameValidator.cannotContainSpace])],
      email: ["",  Validators.compose([Validators.required,Validators.pattern(CONSTANT.EMAIL_REGEX)])],
      phoneNumber: [""],
      assignGroupIds: ["", Validators.compose([Validators.required])],
      title: ["", Validators.compose([Validators.required,Validators.minLength(3),Validators.maxLength(50),Validators.pattern("[a-zA-Z][a-zA-Z ]+"),UsernameValidator.cannotContainSpace])],
      linkedin: ["", Validators.pattern(CONSTANT.URL_REGEX)],
      groupPermissions: [""],
    });
   }
  ngOnInit(): void {
    this.userID = this.route.snapshot.paramMap.get("id")
		if (this.userID) {
			this.titles = "Edit";
			this.getDetails();
		} else {
			this.titles = "Add";
		}
    this.getAllGroups();
    this.dropdownSettings = {
			singleSelection: true,
			idField: "id",
			textField: "groupName",
			itemsShowLimit: 1,
			allowSearchFilter: true,
		};
  }

  getDetails(){
    this.api.getData(apiUrl._usersDetail + "/" + this.userID, "")
      .subscribe(
        async (res) => {
          this.usersData = res.data;
          const group:any=[];
          this.usersData.assign_user_groups.map((item:any)=>{
            group.push({id:item.group_permission?.id, groupName:item.group_permission?.groupName})
          })
          const permission:any=[];
          Object.entries(this.usersData.recruiter_group_permissions[0]).forEach(entry => {
            const [key, value] = entry
            for(let i=0; i< this.accessList.length;i++){
              for(let j = 0; j < this.accessList[i].placeholder.length; j++){
                if (key == this.accessList[i].placeholder[j].key && value == 1){
                  this.accessList[i].placeholder[j].permission = 1;
                  permission.push(this.accessList[i].placeholder[j].permission)
                }
              }
            }
          })
           
          this.usersForm.patchValue({
            ...this.usersData,
            assignGroupIds: group,
            groupPermissions: permission
          }); 
        },
        (err) => {
          console.log(err.error.message, "error");
        }
      );
  } 
  submitUser(){ 
    if(this.usersForm.value.linkedin != null){
      var t = "https://www."; 
      var w = "www"; 
      if(this.usersForm.value.linkedin.toString() != "" && !this.usersForm.value.linkedin.toString().startsWith(t)&& !this.usersForm.value.linkedin.toString().startsWith(w)){
        this.usersForm.patchValue({
          linkedin : t +this.usersForm.value.linkedin
        })
      } else if(this.usersForm.value.linkedin.toString() != "" && this.usersForm.value.linkedin.toString().startsWith(w)){  
        this.usersForm.patchValue({
          linkedin : "https://" +this.usersForm.value.linkedin
        })
      } 
    } 
    if(this.usersForm.valid){
      const myObj :any= []
      let selectedNumber=0
      for(let i = 0 ; i < this.accessList.length ; i++){
        for(let j = 0; j < this.accessList[i].placeholder.length; j++){
          if(this.accessList[i].placeholder[j].permission == 1 || this.accessList[i].placeholder[j].permission == 0){
            myObj.push(
              {
                "module":this.accessList[i].placeholder[j].key,
                "permission":this.accessList[i].placeholder[j].permission
              }
            )
            selectedNumber = selectedNumber + 1
          }
        }
      }
      let selectedGroup:any = [];
      for(let i = 0; i < this.usersForm.value.assignGroupIds.length; i++){
				selectedGroup.push({"groupPermissionId":this.usersForm.value.assignGroupIds[i].id});
			} 
      this.usersForm.patchValue({ 
        assignGroupIds:selectedGroup,
        groupPermissions:myObj,
      })
      // this.api.showLoader=false
      // this.api.loader(false);  
      if(this.userID){   
        delete this.usersForm.value.email
        this.api.putData(apiUrl._users, this.removeEmptyFiled(this.usersForm))
					.subscribe(() => {
            this.toastrService.success("User successfully updated.");
						this.router.navigate(["/users"]);
					})
      }else {   
        delete this.usersForm.value.id;
        this.api.postData(apiUrl._users, this.removeEmptyFiled(this.usersForm))
					.subscribe(() => {
            this.toastrService.success("User added successfully.");
						this.router.navigate(["/users"]);
					})
      }
    }else {
			this.showError = true 
			setTimeout(() => {this.showError = false}, 5000  )
		}
  }

  // ============ Multiple dropdown functionality =============
  onItemSelect(item: any) {
    if (!this.userID) {
      this.clearAllPermissionsInAccessList();
    }
    console.log(item); 
    const permission:any=[];
    this.allGroup.map((gId:any)=>{
      if(item.id == gId.id){
        console.log(gId,'gId');
        this.selectDeselectPermissionsFromGroup(gId, 1)
        this.updatePermissionsInForm();
    }
  })
    console.log(permission,'permission');
    
    
  }

  clearAllPermissionsInAccessList() {
    for(let i=0; i< this.accessList.length;i++){
      for(let j = 0; j < this.accessList[i].placeholder.length; j++){
        this.accessList[i].placeholder[j].permission = 0;
      }
    }
  }

  updatePermissionsInForm() {
    const permission:any=[];
    for(let i=0; i< this.accessList.length;i++){
      for(let j = 0; j < this.accessList[i].placeholder.length; j++){
        if (this.accessList[i].placeholder[j].permission == 1){
          permission.push(this.accessList[i].placeholder[j].permission)
        }
      }
    }
    this.usersForm.patchValue({
      groupPermissions: permission
    })
  }

  selectDeselectPermissionsFromGroup(group, select) {
    Object.entries(group).forEach(entry => {
      const [key, value] = entry
      for(let i=0; i< this.accessList.length;i++){
        for(let j = 0; j < this.accessList[i].placeholder.length; j++){
          if (key == this.accessList[i].placeholder[j].key){
            if (select == 1 && value == 1) {
              this.accessList[i].placeholder[j].permission = 1;
            } else if (select == 0 && value == 1) {
              this.accessList[i].placeholder[j].permission = 0;
            }
          }
        }
      }
    }) 
  }

  onItemDeSelect(item:any) {
    const permission:any=[];

    if (this.userID) {
      this.allGroup.map((group)=> {
        if (group.id == this.usersData.assign_user_groups[0].group_permission?.id) {
          this.selectDeselectPermissionsFromGroup(group, 0);
          this.updatePermissionsInForm();
        }
      })
    } else {
      this.clearAllPermissionsInAccessList();
    }

    this.usersForm.controls['groupPermissions'].reset(); 
    this.usersForm.patchValue({
      groupPermissions: permission
    })
  } 
  // =============================================

  clickEvent(i,j){
		this.accessList[i].placeholder[j].permission = this.accessList[i].placeholder[j].permission == 0 ? 1 : 0
	}

  getAllGroups() {
    this.api.showLoader=false
    this.api.loader(false);  
		this.api.getData(apiUrl._groupPermission , "")
			.subscribe(async (res) => {
				this.allGroup = res.data.groupPermission
			},
			err => {
				console.log(err.error.message, "error")
			})
	}

  capitalizeFirstLetter(value: any) {
    return value.charAt(0).toUpperCase() + value.slice(1);
  }

  // removeEmptyFiled
  removeEmptyFiled(form){
    const formValues = form.value;
    const formKeys = Object.keys(formValues);
    if (formKeys.length) {
      for (let i = 0; i < formKeys.length; i++) {
        if (
          formValues[formKeys[i]] == null ||
          formValues[formKeys[i]] == undefined ||
          formValues[formKeys[i]] == ""
        ) {
          delete formValues[formKeys[i]];
        }
      }
    }
  
    return formValues
  }
}